/**
 * Decides `width` of navigation button based on `navigation.size`.
 *
 * @param param0 object containing `size` attribute from `navigation`.
 * @returns `width` of navigation button.
 */
export const getNavigationArrowWidth = ({
  size
}) => size === 'small' ? 30 : 60;
//# sourceMappingURL=getNavigationArrowWidth.js.map